/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ToDoTaskRow } from './ToDoTaskRow';
import {
    ToDoTaskRowFromJSON,
    ToDoTaskRowFromJSONTyped,
    ToDoTaskRowToJSON,
    ToDoTaskRowToJSONTyped,
} from './ToDoTaskRow';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface WidgetDataToDoWidgetData
 */
export interface WidgetDataToDoWidgetData {
    /**
     * 
     * @type {string}
     * @memberof WidgetDataToDoWidgetData
     */
    $type?: WidgetDataToDoWidgetDataTypeEnum;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof WidgetDataToDoWidgetData
     */
    total: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Array<ToDoTaskRow>}
     * @memberof WidgetDataToDoWidgetData
     */
    items: Array<ToDoTaskRow>;
}


/**
 * @export
 */
export const WidgetDataToDoWidgetDataTypeEnum = {
    ToDo: 'to-do'
} as const;
export type WidgetDataToDoWidgetDataTypeEnum = typeof WidgetDataToDoWidgetDataTypeEnum[keyof typeof WidgetDataToDoWidgetDataTypeEnum];


/**
 * Check if a given object implements the WidgetDataToDoWidgetData interface.
 */
export function instanceOfWidgetDataToDoWidgetData(value: object): value is WidgetDataToDoWidgetData {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function WidgetDataToDoWidgetDataFromJSON(json: any): WidgetDataToDoWidgetData {
    return WidgetDataToDoWidgetDataFromJSONTyped(json, false);
}

export function WidgetDataToDoWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDataToDoWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
        'total': ApiUserTasksGetPageParameterFromJSON(json['total']),
        'items': ((json['items'] as Array<any>).map(ToDoTaskRowFromJSON)),
    };
}

export function WidgetDataToDoWidgetDataToJSON(json: any): WidgetDataToDoWidgetData {
    return WidgetDataToDoWidgetDataToJSONTyped(json, false);
}

export function WidgetDataToDoWidgetDataToJSONTyped(value?: WidgetDataToDoWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$type': value['$type'],
        'total': ApiUserTasksGetPageParameterToJSON(value['total']),
        'items': ((value['items'] as Array<any>).map(ToDoTaskRowToJSON)),
    };
}

